<template>
  <div>
    <v-menu
      v-model="menu2"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="date"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        no-title
        v-model="date"
        @input="menu2 = false"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "datepicker-input",
  props: ["initialDate"],
  data() {
    return {
      date: this.initialDate,
      menu2: false
    };
  },
  watch: {
    date: {
      handler() {
        this.$emit("change", this.date);
      }
    }
  }
};
</script>
